
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("75uOu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");

/**
 * @generated SignedSource<<7c7edc88c3a92e3b433dedf65e3db2b4>>
 * @relayHash 82edd5bab8c0bf68a1d51c4ff73be3eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eff17170e51b7f3f62f2dfc3cd38656c3039f62e42c8e30f9ab2bd99fe2e6baa
const $d1bc84db548bf65d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v4 = {
        "defaultValue": 20,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatuses",
                    "variableName": "contentStatuses"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceWorkflowApplicationHistoryConnection",
            "kind": "LinkedField",
            "name": "confluence_workflowApplicationHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceWorkflowApplicationHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        },
                        {
                            "concreteType": "ConfluenceWorkflowApplicationHistoryEntry",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "workflowApplicationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "workflowReviewId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "contentVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "contentStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "action"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "triggerSource"
                                },
                                {
                                    "concreteType": "ConfluenceApprovalsDate",
                                    "kind": "LinkedField",
                                    "name": "creationDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ConfluenceWorkflowApplicationHistoryActor",
                                    "kind": "LinkedField",
                                    "name": "actor",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ConfluenceWorkflowApplicationHistoryTargetPrincipal",
                                    "kind": "LinkedField",
                                    "name": "targetPrincipal",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "principalType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "principalId"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ConfluenceWorkflowApplicationHistoryReviewDecision",
                                    "kind": "LinkedField",
                                    "name": "reviewDecision",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "decisionStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "comment"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ConfluenceApprovalsWorkflowStatus",
                                    "kind": "LinkedField",
                                    "name": "workflowStatus",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "allowsReviews"
                                        },
                                        {
                                            "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                                            "kind": "LinkedField",
                                            "name": "displayProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "color"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "icon"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluencePageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalActivityHistoryQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalActivityHistoryQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "82edd5bab8c0bf68a1d51c4ff73be3eb",
            "id": "eff17170e51b7f3f62f2dfc3cd38656c3039f62e42c8e30f9ab2bd99fe2e6baa",
            "metadata": {},
            "name": "ApprovalActivityHistoryQuery",
            "operationKind": "query",
            "text": "query ApprovalActivityHistoryQuery($cloudId:ID!,$contentId:ID!,$first:Int=20,$after:String,$contentStatuses:[GraphQLContentStatus]!){confluence_workflowApplicationHistory(cloudId:$cloudId,contentId:$contentId,first:$first,after:$after,contentStatuses:$contentStatuses){edges{cursor,node{id,workflowApplicationId,workflowReviewId,contentId,contentVersion,contentStatus,action,triggerSource,creationDate{value},actor{accountId,displayName},targetPrincipal{principalType,principalId},reviewDecision{decisionStatus,comment},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$d1bc84db548bf65d$var$node.hash = "6cc0197d8f4cc9a98f560e1afe0b1fca";
var $d1bc84db548bf65d$export$2e2bcd8739ae039 = $d1bc84db548bf65d$var$node;


const $736dd717dd1a147b$export$d70c738ce7ba03aa = (0, $d1bc84db548bf65d$export$2e2bcd8739ae039);


// `action` is a backend String, not an enum; unknown/future values map to
// `UNKNOWN` so new backend events don't break rendering.
const $0f8086e1b26220a1$var$KNOWN_ACTIONS = new Set([
    'REVIEW_STARTED',
    'REVIEW_REAPPROVAL_STARTED',
    'REVIEW_APPROVED',
    'REVIEW_DENIED',
    'REVIEW_CANCELED',
    'REVIEW_INVALIDATED',
    'DRAFT_PROMOTED',
    'REVIEWER_ADDED',
    'REVIEWER_REMOVED',
    'REVIEWER_REQUIRED_CHANGED',
    'REVIEWER_DECISION_SUBMITTED',
    'REVIEWER_DECISION_UPDATED'
]);
const $0f8086e1b26220a1$var$ACTION_DISPLAY_STATUS = {
    REVIEW_STARTED: 'IN_REVIEW',
    REVIEW_REAPPROVAL_STARTED: 'IN_REVIEW',
    REVIEW_APPROVED: 'APPROVED',
    REVIEW_DENIED: 'CHANGES_REQUESTED',
    REVIEW_CANCELED: 'CANCELLED',
    REVIEW_INVALIDATED: 'CANCELLED',
    DRAFT_PROMOTED: 'UPDATED',
    REVIEWER_ADDED: 'IN_REVIEW',
    REVIEWER_REMOVED: 'IN_REVIEW',
    REVIEWER_REQUIRED_CHANGED: 'UPDATED',
    REVIEWER_DECISION_SUBMITTED: 'UPDATED',
    REVIEWER_DECISION_UPDATED: 'UPDATED'
};
// Backend-defined workflow-status id for "changes requested". The id is
// locale-independent, unlike the display name, so it is the only reliable
// signal for this state. See the Confluence workflow-status schema.
const $0f8086e1b26220a1$var$CHANGES_REQUESTED_WORKFLOW_STATUS_ID = '3';
const $0f8086e1b26220a1$export$e2f26dc63c8c0686 = (action)=>{
    if (action && $0f8086e1b26220a1$var$KNOWN_ACTIONS.has(action)) return action;
    return 'UNKNOWN';
};
const $0f8086e1b26220a1$export$18d5cfff631fc6ad = (action, decisionStatus = null, workflowStatus = null)=>{
    if (action === 'UNKNOWN') return 'UPDATED';
    // A reviewer's decision only carries an approve/deny status; cancellation is a
    // cycle-level action (REVIEW_CANCELED), handled where cycle status is derived.
    if (action === 'REVIEWER_DECISION_SUBMITTED' || action === 'REVIEWER_DECISION_UPDATED') {
        if (decisionStatus === 'REVIEWER_APPROVED') return 'APPROVED';
        if (decisionStatus === 'REVIEWER_DENIED') return 'CHANGES_REQUESTED';
    }
    if (action === 'DRAFT_PROMOTED' && workflowStatus) {
        if (workflowStatus.id === $0f8086e1b26220a1$var$CHANGES_REQUESTED_WORKFLOW_STATUS_ID) return 'CHANGES_REQUESTED';
        if (workflowStatus.allowsReviews) return 'IN_REVIEW';
        return 'APPROVED';
    }
    return $0f8086e1b26220a1$var$ACTION_DISPLAY_STATUS[action];
};
const $0f8086e1b26220a1$var$mapConfluencePrincipalType = (principalType)=>principalType ?? null;
const $0f8086e1b26220a1$var$mapConfluenceReviewerDecisionState = (decisionStatus)=>decisionStatus ?? null;
const $0f8086e1b26220a1$var$shouldOmitReviewDecisionComment = (action)=>action === 'REVIEW_CANCELED' || action === 'REVIEW_INVALIDATED';
const $0f8086e1b26220a1$export$45e47f50a8e59c30 = (node)=>{
    if (!node?.id) return null;
    const action = $0f8086e1b26220a1$export$e2f26dc63c8c0686(node.action);
    const workflowStatus = node.workflowStatus;
    const mappedWorkflowStatus = workflowStatus ? {
        id: workflowStatus.id ?? null,
        allowsReviews: workflowStatus.allowsReviews ?? null,
        name: workflowStatus.displayProperties?.name ?? null,
        description: workflowStatus.displayProperties?.description ?? null,
        color: workflowStatus.displayProperties?.color ?? null,
        icon: workflowStatus.displayProperties?.icon ?? null
    } : null;
    const decisionStatus = node.reviewDecision?.decisionStatus ?? null;
    return {
        id: node.id,
        action: action,
        rawAction: node.action ?? null,
        displayStatus: $0f8086e1b26220a1$export$18d5cfff631fc6ad(action, decisionStatus, mappedWorkflowStatus),
        creationDate: node.creationDate?.value ?? null,
        contentStatus: node.contentStatus ?? null,
        contentVersion: node.contentVersion ?? null,
        triggerSource: node.triggerSource ?? null,
        actor: node.actor ? {
            accountId: node.actor.accountId ?? null,
            displayName: node.actor.displayName ?? null
        } : null,
        targetPrincipal: node.targetPrincipal ? {
            principalId: node.targetPrincipal.principalId ?? null,
            principalType: $0f8086e1b26220a1$var$mapConfluencePrincipalType(node.targetPrincipal.principalType)
        } : null,
        reviewDecision: node.reviewDecision ? {
            decisionStatus: $0f8086e1b26220a1$var$mapConfluenceReviewerDecisionState(node.reviewDecision.decisionStatus),
            comment: $0f8086e1b26220a1$var$shouldOmitReviewDecisionComment(action) ? null : node.reviewDecision.comment ?? null
        } : null,
        workflowStatus: mappedWorkflowStatus,
        workflowApplicationId: node.workflowApplicationId ?? null,
        workflowReviewId: node.workflowReviewId ?? null
    };
};
const $0f8086e1b26220a1$export$2a5b62789eae2316 = (data)=>{
    const connection = data?.confluence_workflowApplicationHistory;
    const edges = connection?.edges ?? [];
    const items = [];
    for (const edge of edges){
        const item = $0f8086e1b26220a1$export$45e47f50a8e59c30(edge?.node);
        if (item) items.push(item);
    }
    return {
        items: items,
        pageInfo: {
            endCursor: connection?.pageInfo?.endCursor ?? null,
            hasNextPage: connection?.pageInfo?.hasNextPage ?? false
        }
    };
};
const $0f8086e1b26220a1$export$ec7caddde472bba7 = (previousResult, fetchMoreResult)=>{
    const previousConnection = previousResult.confluence_workflowApplicationHistory;
    const nextConnection = fetchMoreResult?.confluence_workflowApplicationHistory;
    if (!previousConnection) return fetchMoreResult ?? previousResult;
    if (!nextConnection) return previousResult;
    // Generated type marks cursor as non-nullable, but we guard against falsy
    // cursors defensively (TODO CCIMPORTER-2844: confirm with backend, then drop
    // this guard or fix the schema upstream).
    const seenCursors = new Set();
    const seenNodeIds = new Set();
    for (const edge of previousConnection.edges ?? []){
        if (edge?.cursor) seenCursors.add(edge.cursor);
        if (edge?.node?.id) seenNodeIds.add(edge.node.id);
    }
    const nextEdges = [];
    for (const edge of nextConnection.edges ?? []){
        const cursor = edge?.cursor;
        const nodeId = edge?.node?.id;
        if (cursor) {
            if (seenCursors.has(cursor)) continue;
            seenCursors.add(cursor);
        }
        if (nodeId) {
            if (seenNodeIds.has(nodeId)) continue;
            seenNodeIds.add(nodeId);
        }
        nextEdges.push(edge);
    }
    return {
        ...previousResult,
        confluence_workflowApplicationHistory: {
            ...nextConnection,
            edges: [
                ...previousConnection.edges ?? [],
                ...nextEdges
            ],
            pageInfo: nextConnection.pageInfo
        }
    };
};
const $0f8086e1b26220a1$var$getPageSizeBucket = (itemCount)=>{
    if (itemCount === 0) return 'empty';
    if (itemCount === 1) return 'one';
    if (itemCount < 20) return 'few';
    return 'many';
};
const $0f8086e1b26220a1$export$b55e4ab1f9fdbda8 = (item, history)=>{
    return {
        action: item.action,
        displayStatus: item.displayStatus,
        contentStatus: item.contentStatus,
        hasActor: Boolean(item.actor),
        hasComment: Boolean(item.reviewDecision?.comment),
        hasNextPage: history.pageInfo.hasNextPage,
        pageSizeBucket: $0f8086e1b26220a1$var$getPageSizeBucket(history.items.length)
    };
};


const $f8adb5b9883132c1$export$446128736d436012 = 20;
const $f8adb5b9883132c1$var$CURRENT_CONTENT_STATUS = 'CURRENT';
function $f8adb5b9883132c1$export$87654aabb918ef66({ cloudId: cloudId, contentId: contentId, first: first = $f8adb5b9883132c1$export$446128736d436012, skip: skip = false }) {
    // Inline rollout checks, ordered to short-circuit: gate before experiment
    // (per `no-premature-experiment-exposure`), config last. The config exposes
    // its boolean under `value` (not `isEnabled`).
    const shouldSkip = skip || !cloudId || !contentId || !(0, $9wGTI.fg)('confluence_approvals_beta') || !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) || (0, $6mKj3.UNSAFE_noExposureExp)('confluence_approvals_activity_log')[0].get('value', false) !== true;
    const variables = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId ?? '',
            contentId: contentId ?? '',
            first: first,
            after: null,
            contentStatuses: [
                $f8adb5b9883132c1$var$CURRENT_CONTENT_STATUS
            ]
        }), [
        cloudId,
        contentId,
        first
    ]);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $736dd717dd1a147b$export$d70c738ce7ba03aa), {
        variables: variables,
        skip: shouldSkip,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "@confluence/approvals"
    });
    const history = (0, $cozmU.useMemo)(()=>(0, $0f8086e1b26220a1$export$2a5b62789eae2316)(data), [
        data
    ]);
    // Mark surfaced errors as handled to avoid duplicate reporting from the global
    // boundary; the error is still returned to callers for rendering.
    (0, $cozmU.useEffect)(()=>{
        if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    // Surfaced separately from the initial-load `error` so a failed page fetch
    // can show an inline retry without replacing the already-loaded list.
    const [loadNextPageError, setLoadNextPageError] = (0, $cozmU.useState)(null);
    const loadNextPage = (0, $cozmU.useCallback)(async ()=>{
        const endCursor = history.pageInfo.endCursor;
        if (!history.pageInfo.hasNextPage || !endCursor || shouldSkip) return;
        setLoadNextPageError(null);
        try {
            await fetchMore({
                variables: {
                    ...variables,
                    after: endCursor
                },
                updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>(0, $0f8086e1b26220a1$export$ec7caddde472bba7)(previousResult, fetchMoreResult)
            });
        } catch (fetchMoreError) {
            // Mark handled (fire-and-forget callers shouldn't trigger unhandled
            // rejections) but still surface it so the panel can offer a retry.
            (0, $7Sm4c.markErrorAsHandled)(fetchMoreError);
            setLoadNextPageError(fetchMoreError instanceof Error ? fetchMoreError : new Error('Failed to load more activity'));
        }
    }, [
        fetchMore,
        history.pageInfo.endCursor,
        history.pageInfo.hasNextPage,
        shouldSkip,
        variables
    ]);
    return {
        ...history,
        loading: loading,
        error: error,
        loadNextPage: loadNextPage,
        loadNextPageError: loadNextPageError,
        refetch: refetch
    };
}
module.exports["useApprovalActivityHistory"] = $f8adb5b9883132c1$export$87654aabb918ef66;

});


//# sourceMappingURL=EditorContentStateComponent.4d6dcb89.js.map
